import { make } from 'vuex-pathify'
import fuzzySearch from '@/helpers/fuzzy-search'
import axios from 'axios'

const apiEndpoint = process.env.VUE_APP_GRAPHQL_ENDPOINT

const state = {
  groups: [],
  selectedGroup: null,
}

export default {
  namespaced: true,

  state,

  mutations: make.mutations(state),

  actions: {
    ...make.actions(state),

    async getGroups({ commit, rootState }) {
      let { data } = await axios.post(`${apiEndpoint}`, {
        query: `query getGroups($organizationIds: [uuid!]!) {
          groups(order_by: {title: asc}, where: {ownerOrganizationId: {_in: $organizationIds}}) {
            id
            title
            shortName
            slug
            tags
            abbreviation
            description
            addressStreet
            addressCity
            addressState
            addressZip
            buildingName
            contactName
            contactEmail
            contactPhone
            contactFax
            linkLabel
            linkUrl
            officeHours
            ownerOrganization {
              id
              title
              website
            }
            parentGroup {
              id
              title
            }
            childrenGroups {
              id
              title
            }
          }
        }
        `,
        variables: {
          organizationIds: rootState.selectedOrganizationId
            ? [rootState.selectedOrganizationId]
            : [],
        },
      })
      commit('SET_GROUPS', data && data.data && data.data.groups)
    },
    async selectGroupBySlug({ commit, rootState }, slug) {
      if (!rootState.selectedOrganizationId || !slug) return
      let { data } = await axios.post(`${apiEndpoint}`, {
        query: `query getSelectedGroup($organizationId: uuid!, $slug: String) {
          groups(where: {
            ownerOrganizationId: {_eq: $organizationId},
            slug: {_eq: $slug}
          }) {
            id
            title
            shortName
            slug
            tags
            abbreviation
            description
            addressStreet
            addressCity
            addressState
            addressZip
            buildingName
            contactName
            contactEmail
            contactPhone
            contactFax
            linkLabel
            linkUrl
            officeHours
            ownerOrganization {
              id
              title
              website
            }
            parentGroup {
              id
              title
            }
            childrenGroups {
              id
              title
            }
            people(where: {person: {isPublic: {_eq: true}}},order_by:{ person:{ lastName: asc } }) {
              person {
                id
                displayName
                title
                biography
                credentials
                email
                phone
                photoUrl
                employee {
                  organization {
                    title
                  }
                  office
                  jobTypes
                }
              }
            }
          }

        }
        `,
        variables: {
          organizationId: rootState.selectedOrganizationId,
          slug,
        },
      })
      commit(
        'SET_SELECTED_GROUP',
        data &&
          data.data &&
          data.data.groups &&
          data.data.groups.length &&
          data.data.groups[0]
      )
    },
  },

  getters: {
    filteredGroups: (state, getters, rootState) => {
      // Return all groups if keywords is empty
      if (!rootState.keywords) return state.groups
      return state.groups.filter(d => {
        return fuzzySearch(rootState.keywords, d.title)
      })
    },

    filteredGroupsCount: (state, getters) => {
      return getters.filteredGroups.length
    },

    filteredGroupsListItems: (state, getters) => {
      return getters.filteredGroups
        .map(d => {
          return {
            group: d,
            label: d.title,
            thumbnail: '',
            textAvatar: '',
            // description: d.buildingName,
            description: '',
            badge: '',
            condensed: false,
            actionable: true,
            bordered: true,
            checked: false,
            alignTop: false,
            tags: [],
          }
        })
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    },
    selectedGroupPeopleListItems: state => {
      if (
        state.selectedGroup &&
        state.selectedGroup.people &&
        state.selectedGroup.people.length
      ) {
        return state.selectedGroup.people
          .map(p => p.person)
          .map(p => {
            return {
              person: { ...p },
              label: `${p.displayName}`,
              // thumbnail: p.picture.thumbnail,
              textAvatar: p.displayName
                .split(' ')
                .map(n => n[0])
                .join(''),
              description: `${p.title}<br><small>${(p.employee &&
                (p.employee.office ||
                  (p.employee.organization &&
                    p.employee.organization.title))) ||
                state.selectedGroup.title}</small>`,
              badge: '',
              condensed: false,
              actionable: true,
              bordered: true,
              checked: false,
              alignTop: true,
              tags: [],
              // to: `people/${p.id.value}`,
            }
          })
      }
      return []
    },
  },
}
